import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";
import { LabelWithDetail } from "./LabelWithDetail";

interface SpaceListCardProps {
  resources: Array<{ name: string; id: string; space_type?: string }>;
}

export const SpaceListCard = ({ resources }: SpaceListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.spaces")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_spaces_found")}
    renderItem={space => (
      <LabelWithDetail label={space.name} detail={space.space_type} />
    )}
    getItemKey={space => space.id}
  />
);
